<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            <div class="text--secondary">List Wilayah</div>
          </v-card-title>
          <v-card-subtitle class="mt-3">
            <v-sheet class="d-sm-flex align-center justify-space-between">
              <v-btn
                :block="$vuetify.breakpoint.name === 'xs'"
                color="light-green"
                class="text-capitalize"
                dark
                elevation="2"
                @click.stop="dialog.form = true"
              >
                <v-icon small>mdi-plus</v-icon> Wilayah
              </v-btn>
              <v-sheet class="d-sm-flex mt-4 mt-sm-0 align-center">
                <v-text-field
                  dense
                  outlined
                  v-model="search"
                  hide-details
                  placeholder="Cari Wilayah . . ."
                  clearable
                  color="light-green"
                  prepend-inner-icon="mdi-magnify"
                  class="mb-4 mb-sm-0 mr-sm-2"
                  :full-width="$vuetify.breakpoint.name === 'xs'"
                >
                </v-text-field>
              </v-sheet>
            </v-sheet>
          </v-card-subtitle>
          <v-card-text>
            <v-divider class="my-2" />
            <v-skeleton-loader
              class="ma-auto"
              :loading="status === 'pending'"
              transition="fade-transition"
              :tile="false"
              type="table-row"
              v-for="index in status === 'pending' ? 10 : 1"
              :key="index"
            >
              <v-data-table
                v-show="units.length >= 1"
                :headers="headers"
                mobile-breakpoint="1"
                hide-default-footer
                :items="units"
                fixed-header
                min-height="250px"
                :height="
                  $vuetify.breakpoint.name !== 'xs' ? 'calc(100vh - 50vh)' : ''
                "
              >
                <template v-slot:[`item.aksi`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        color="blue darken-1"
                        elevation="0"
                        class="text-capitalize white--text ma-1"
                        v-bind="attrs"
                        v-on="on"
                        @click="handleUpdate(item)"
                      >
                        <v-icon small>mdi-square-edit-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        color="red"
                        elevation="0"
                        class="text-capitalize white--text ma-1"
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          detail = item;
                          dialog.delete = true;
                        "
                      >
                        <v-icon small>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.unitTypeName`]="{ item }">
                  {{ item.unitAttributes.entitas || '-' }}
                </template>
              </v-data-table>
            </v-skeleton-loader>
            <div
              class="text-center text--secondary"
              v-show="status !== 'pending' && units.length < 1"
            >
              <v-icon
                style="font-size: 60px; margin-top: 1.5em"
                color="light-green"
              >
                mdi-close-circle-outline
              </v-icon>
              <p class="headline font-weight-bold mt-2 mb-1">Data kosong</p>
              <p>Data yang Anda cari tidak ada disini</p>
            </div>
          </v-card-text>
          <v-card-actions class="pb-6 px-6">
            <v-row>
              <v-col
                cols="5"
                v-if="
                  pagination.totalData > 0 && $vuetify.breakpoint.name !== 'xs'
                "
              >
                <div class="body-2 font-weight-bold mt-4">
                  Total {{ pagination.totalData }} data
                </div>
              </v-col>
              <v-col
                v-if="pagination.totalPage > 1"
                :cols="$vuetify.breakpoint.name !== 'xs' ? '7' : '12'"
              >
                <div class="float-sm-right">
                  <v-pagination
                    v-model="page"
                    :length="pagination.totalPage"
                    :total-visible="5"
                    color="light-green"
                    @input="getUnitsHandler()"
                    circle
                  >
                  </v-pagination>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <DialogForm
      v-model="dialog.form"
      :detail="detail"
      @submitted="getUnitsHandler()"
    />
    <DialogDelete
      v-model="dialog.delete"
      :detail="detail"
      @deleted="getUnitsHandler()"
    />
  </v-container>
</template>

<script>
import axios from 'axios';
import debounce from 'lodash.debounce';

import DialogForm from './components/DialogForm.vue';
import DialogDelete from './components/DialogDelete.vue';
export default {
  components: {
    DialogForm,
    DialogDelete
  },

  data() {
    return {
      search: '',
      detail: {},
      units: [],
      page: 1,
      dialog: {
        form: false,
        delete: false
      },
      pagination: {
        totalData: 0,
        totalPage: 0
      },
      status: 'idle',
      selectedPage: '',
      headers: [
        {
          text: 'Aksi',
          value: 'aksi',
          align: 'start',
          width: 200,

          sortable: false,
          class: 'font-weight-black body-2'
        },
        {
          text: 'Nama',
          width: 200,
          class: 'font-weight-black body-2',
          value: 'name'
        },
        {
          text: 'Tipe',
          width: 200,
          class: 'font-weight-black body-2',
          value: 'unitTypeName'
        },
        {
          text: 'Alamat',
          width: 200,
          class: 'font-weight-black body-2',
          value: 'address'
        }
      ]
    };
  },

  watch: {
    search: {
      handler: debounce(function() {
        this.page = 1;
        this.getUnitsHandler();
      }, 500),
      immediate: true
    }
  },

  methods: {
    async getUnitsHandler() {
      this.status = 'pending';
      try {
        const {
          data: { data, meta }
        } = await axios.get('https://api-v2-monsta-mls.monsta.id/api/units', {
          headers: {
            Authorization:
              'Bearer oat_NQ.LVRzS0hkVTg1OEZXZjh6d1A2S0R0N3hTQ0FKZU9WVnEyaEJERVc4cTE0NDY3NDM0MzA'
          },
          params: {
            search: this.search || undefined,
            page: this.page
          }
        });
        this.units = data;
        this.pagination = {
          totalData: meta.total,
          totalPage: meta.lastPage
        };
        return data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.status = 'idle';
      }
    },
    handleUpdate(item) {
      this.dialog.form = true;
      this.detail = item;
    }
  }
};
</script>
